<template>
  <div class="about__entry" id="vision">
    <div class="about__entry--content">
      <h1 class="about__entry--content--title">{{ $t("aboutTranslate.aboutEntryTitle") }}</h1>
      <p class="about__entry--content--body">{{ $t("aboutTranslate.aboutEntrySubtitle") }}</p><br>
      <p class="about__entry--content--body about__entry--content--body--second">{{ $t("aboutTranslate.aboutEntrySubtitleSecond") }}</p>
    </div>
    <div class="about__entry--anchor-list">
      <a v-on:click="clickfuncVision()">{{ $t("aboutTranslate.aboutEntryAnchorToFirstSection") }}</a>
      <a v-on:click="clickfuncHistory()">{{ $t("aboutTranslate.aboutEntryAnchorToSecondSection") }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about-entry',
  data() {
    return {
      locale: 'fr'
    }
  },
  methods :{
    clickfuncHistory() {
      this.$SmoothScroll(document.getElementById('history'));
    },
    clickfuncVision() {
      this.$SmoothScroll(document.getElementById('vision'));
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>

<style lang="css">
</style>
